"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var Loading = function () { return (React.createElement("div", { className: 'center' },
    React.createElement(sok_ui_1.LoadingSpinner, null))); };
exports.Loading = Loading;
